import { createEscolaRoute, escolaEditRoute } from "library/Routes";
import { ESCOLA_ETAPAS_PARAMS_URL } from "models/escola";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { TipoPrograma } from "store/modules/EscolasTypes";
import { EscolaEditTabs } from "../__enum";
import { useHistory, useLocation } from "react-router-dom";
import { useCallback, useMemo } from "react";
import { Modo, TITULOS } from "../__types";

export default function useProgramas() {
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const location = useLocation();
  const history = useHistory();

  const cadastroEscola = useMemo(() => location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO), [location.pathname]);

  const programaNomes: Record<TipoPrograma, string> = {
    [TipoPrograma.UniaoFazAVida]: 'A União Faz a Vida',
    [TipoPrograma.CooperativaEscolar]: 'Cooperativas Escolares',
    [TipoPrograma.FinancasNaMochila]: 'Finanças na Mochila',
  };

  const getNomePrograma = (tipo: string): string => {
    return programaNomes[tipo as TipoPrograma] || 'Programa desconhecido';
  };

  const titleMap = {
    duplicar: {
      [TipoPrograma.UniaoFazAVida]: languageValues.duplicarPeriodoTitlePufv,
      [TipoPrograma.CooperativaEscolar]: languageValues.duplicarPeriodoTitleCooperativa,
      [TipoPrograma.FinancasNaMochila]: languageValues.duplicarPeriodoTitleFinancas,
    },
    editar: {
      [TipoPrograma.UniaoFazAVida]: languageValues.editPeriodoTitlePufv,
      [TipoPrograma.CooperativaEscolar]: languageValues.editPeriodoTitleCoop,
      [TipoPrograma.FinancasNaMochila]: languageValues.editPeriodoTitleFinancas,
    },
    novo: {
      [TipoPrograma.UniaoFazAVida]: languageValues.newPeriodoTitle,
      [TipoPrograma.CooperativaEscolar]: languageValues.newPeriodoTitleCoop,
      [TipoPrograma.FinancasNaMochila]: languageValues.newPeriodoTitleFinancas,
    },
  };

  const getTitleModal = (tipoPrograma: string | number, key: "cadastrar" | "editar" | "duplicar") => {
    const tipo = Number(tipoPrograma) as unknown as TipoPrograma;
    switch (key) {
      case "editar":
        return titleMap.editar[tipo];
      case "duplicar":
        return titleMap.duplicar[tipo];
      default:
        return titleMap.novo[tipo];
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validationKeyMap: Record<TipoPrograma, string> = {
    [TipoPrograma.UniaoFazAVida]: 'periodoEditing',
    [TipoPrograma.CooperativaEscolar]: 'periodoEditingCoop',
    [TipoPrograma.FinancasNaMochila]: 'periodoEditingFinancas',
  };

  const getPeriodoValidationKey = useCallback((tipoPrograma: TipoPrograma): string => {
    return validationKeyMap[tipoPrograma] || 'periodoEditing';
  }, [validationKeyMap]);

  const retornaListaPeriodos = (idParam: string, navegar?: boolean) => {
    if (navegar) {
      const tab = EscolaEditTabs.ProgramasEducacionais;
      const url = cadastroEscola
        ? createEscolaRoute.getURLWithParams(idParam, tab)
        : escolaEditRoute.getURLWithParams(idParam, tab);
      history.push(url);
    }
  };

  const useTituloModal = (
    key: string,
  ): string => {
    return useMemo(() => {
      const modosValidos: Modo[] = ["cadastrar", "editar", "duplicar"];
      const isModo = (value: any): value is Modo =>
        modosValidos.includes(value);

      if (isModo(key)) {
        return TITULOS[key];
      }

      return "Título padrão";
    }, [key]);
  };

  return {
    getNomePrograma,
    getTitleModal,
    getPeriodoValidationKey,
    retornaListaPeriodos,
    useTituloModal,
    cadastroEscola
  }
}



